import {
  FAST_INITIATING_PARTY_ADVISOR,
  FAST_INITIATING_PARTY_FOUNDER,
  isAdvisorInitiated,
  normalizeInitiatingPartyKey,
  type FastAgreementDraftForm,
  type FastInitiatingPartyKey,
} from '@src/components/sco/Advisors/utils/fastAgreementForm'

export const INITIATING_PARTY_OPTIONS: Array<{
  value: FastInitiatingPartyKey
  label: string
  description: string
}> = [
  {
    value: FAST_INITIATING_PARTY_FOUNDER,
    label: "I'm the founder",
    description: "You'll send this FAST to the advisor.",
  },
  {
    value: FAST_INITIATING_PARTY_ADVISOR,
    label: "I'm the advisor",
    description: "You'll send this FAST to the founder.",
  },
]

export const PARTY_FIELD_COPY = {
  founderNameLabel: 'Founder name',
  founderNamePlaceholder: 'Name on the Company signature',
  founderEmailLabel: 'Founder email',
  founderEmailPlaceholder: 'founder@company.com',
  founderCompanyLabel: 'Founder company',
  founderCompanyPlaceholder: 'Company name on the FAST',
  advisorNameLabel: 'Advisor name',
  advisorNamePlaceholder: 'Name of the person who signs',
  advisorEmailLabel: 'Advisor email',
  advisorEmailPlaceholder: 'advisor@company.com',
  advisorCompanyLabel: 'Advisor company',
  advisorCompanyPlaceholder: 'Holding company or legal entity',
  advisorCompanyHelper:
    'Optional. If the FAST is issued to an entity, the advisor signs as its authorized representative.',
} as const

/** Contracting Advisor party on the paper: entity if set, otherwise the person. */
export const advisorContractingPartyName = (person?: string | null, entity?: string | null) => {
  const company = entity?.trim() || ''
  const name = person?.trim() || ''
  return company || name
}

/** Signature line when the Advisor is a company. */
export const advisorSignatoryLabel = (person?: string | null, entity?: string | null) => {
  const name = person?.trim() || ''
  const company = entity?.trim() || ''
  if (name && company) {
    return `${name}, authorized representative of ${company}`
  }
  return name || company
}

export const sendCtaLabel = (
  initiatingPartyKey?: string | null,
  counterpartyName?: string | null
): string => {
  const name = counterpartyName?.trim()
  if (name) {
    return `Send to ${name}`
  }
  return isAdvisorInitiated(initiatingPartyKey) ? 'Send to founder' : 'Send to advisor'
}

export const withInitiatingParty = (
  form: FastAgreementDraftForm,
  initiatingPartyKey: FastInitiatingPartyKey,
  self?: { name?: string | null; email?: string | null } | null
): FastAgreementDraftForm => {
  const key = normalizeInitiatingPartyKey(initiatingPartyKey)
  const selfName = self?.name?.trim() || ''
  const selfEmail = self?.email?.trim() || ''
  if (key === FAST_INITIATING_PARTY_FOUNDER) {
    return {
      ...form,
      initiatingPartyKey: key,
      founderName: form.founderName.trim() || selfName,
      founderEmail: form.founderEmail.trim() || selfEmail,
    }
  }
  return {
    ...form,
    initiatingPartyKey: key,
    advisorName: form.advisorName.trim() || selfName,
    advisorEmail: form.advisorEmail.trim() || selfEmail,
  }
}
